import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminUsers = {
  staffCreateSuccess: "試験運営スタッフを作成しました",
  candidateCreateSuccess: "受験者を作成しました",
  createUserSuccess: "ユーザーを作成しました",
  userUpdated: "ユーザー情報を更新しました",
  passwordReset: "パスワードをリセットしました",
  accountLocked: "アカウントをロックしました",
  accountUnlocked: "アカウントのロックを解除しました",
  candidateKickedOut: "サインアウトしました。アカウントのログイン状態は無効になりました。",
  importCompleted: "インポート完了：要求 {requested}、新規 {created}、更新 {updated}",
  pageTitleStaff: "試験運営スタッフ管理",
  pageSubtitleStaff: "試験運営スタッフのアカウント、ロール、権限分担を一元管理します。",
  pageTitleCandidate: "受験者管理",
  pageSubtitleCandidate:
    "受験者アカウントを個別に管理し、作成、状態編集、パスワードリセットに対応します。",
  rolePermissionsPageTitle: "ロール権限",
  rolePermissionsPageSubtitle:
    "複数ロールの和集合権限を判断する現在の基準として、試験管理側のロールカタログと権限マトリクスを確認します。",
  pageTitleAll: "ユーザーとロール",
  pageSubtitleAll:
    "試験運営スタッフと受験者アカウントを一元管理し、シードアカウントから運用可能な設定へ段階的に移行します。",
  createStaff: "試験運営スタッフを作成",
  createCandidate: "受験者を作成",
  createUser: "ユーザーを作成",
  totalStaff: "スタッフ総数",
  totalCandidate: "受験者総数",
  totalUsers: "ユーザー総数",
  activeAccounts: "有効アカウント",
  activeUsers: "有効ユーザー",
  lockedAccounts: "ロック中アカウント",
  pendingPasswordChange: "パスワード変更待ち",
  availableRoles: "利用可能なロール",
  createStaffDrawerTitle: "試験運営スタッフを作成",
  createCandidateDrawerTitle: "受験者を作成",
  createUserDrawerTitle: "ユーザーを作成",
  editUserDrawerTitle: "ユーザーを編集",
  editUserDrawerTitleWithId: "ユーザー #{id} を編集",
  resetPasswordDrawerTitle: "パスワードをリセット",
  resetPasswordDrawerTitleWithId: "パスワードをリセット #{id}",
  resetPasswordResultTitle: "パスワードをリセットしました",
  resetPasswordResultHint:
    "以下のログイン情報を保存してください。閉じた後は平文パスワードは表示されません。",
  batchResetPasswordResultTitle: "一括パスワードリセット結果",
  batchResetPasswordResultHint:
    "今回パスワードリセットに成功したアカウント情報です。速やかにコピーして保存してください。",
  batchImportModalTitle: "受験者を一括インポート（Excel）",
  importInvalidArray: "インポートデータ形式が正しくありません",
  importInvalidJson: "Excel の解析に失敗しました",
  importExample: "提供テンプレートを使ってインポートしてください",
  resetPasswordHelp: "{username} に新しいログインパスワードを設定します。",
  searchPlaceholder: "ユーザー名または氏名で検索",
  searchPlaceholderStaff: "ユーザー名または氏名で試験運営スタッフを検索",
  searchPlaceholderCandidate: "ユーザー名または氏名で受験者を検索",
  summary: {
    totalUsers: "ユーザー総数：{count}",
    activeUsers: "有効ユーザー：{count}",
    availableRoles: "利用可能なロール：{count}",
  },
  table: {
    id: "ID",
    username: "ユーザー名",
    fullName: "氏名",
    role: "ロール",
    status: commonShortNouns.status,
    onlineStatus: "オンライン状態",
    phone: "電話番号",
    idCardNo: "身分証",
    expiresAt: "有効期限",
    securityState: "セキュリティ状態",
    superuser: "スーパー管理者",
    lastLogin: "最終ログイン",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
  },
  fields: {
    avatarUrl: "アバター URL",
    phone: "電話番号",
    idCardNo: "身分証番号",
    expiresAt: "有効期限",
    expiresQuickDay: "1日",
    expiresQuickWeek: "1週間",
    expiresQuickMonth: "1か月",
    expiresQuickYear: "1年",
    initialPassword: "初期パスワード",
    newPassword: "新しいパスワード",
    loginAddress: "ログイン URL",
    temporaryPassword: "ランダムパスワード",
    status: commonShortNouns.status,
    superuser: "スーパー管理者",
  },
  actions: {
    batchImport: "一括インポート",
    resetPassword: "パスワードをリセット",
    batchResetPassword: "パスワードを一括リセット ({count})",
    batchClearAvatar: "アバターを一括クリア ({count})",
    batchLock: "一括ロック ({count})",
    batchUnlock: "一括ロック解除 ({count})",
    clearAvatar: "アバターをクリア",
    lock: "ロック",
    unlock: "ロック解除",
    impersonate: "代理ログイン",
    kickout: "サインアウト",
  },
  labels: {
    superuserShort: "超管",
    online: "オンライン",
    offline: "オフライン",
    identitySourceSso: "統一ID",
    identitySourceLocalCandidate: "ローカル受験者",
    identitySourceLocalStaff: "ローカルスタッフ",
    linked: "連携済み",
    unlinked: "未連携",
  },
  messages: {
    candidateCustomFieldsSaved: "受験者のカスタム項目を保存しました",
    batchCustomFieldApplied: "一括設定が完了しました：成功 {success}、失敗 {failed}",
    batchLockCompleted: "一括ロック完了：成功 {success}、失敗 {failed}",
    batchUnlockCompleted: "一括ロック解除完了：成功 {success}、失敗 {failed}",
    batchClearAvatarCompleted: "アバター一括クリア完了：成功 {success}、失敗 {failed}",
    batchResetPasswordCompleted: "一括パスワードリセット完了：成功 {success}、失敗 {failed}",
    batchCustomFieldValueRequired: "少なくとも 1 つの項目値を設定してください",
    selectExcelFileWarning: "先に Excel ファイルを選択してください",
    ssoLinkSuccess: "統一IDの受験者を連携しました：{linked}/{requested}",
  },
  ssoSync: {
    searchPlaceholder: "ユーザー名で統一IDの受験者を検索",
    action: "統一IDの受験者を連携",
    staffAction: "統一IDのスタッフを連携",
    bindAction: "統一IDをバインド",
    unbindAction: "連携解除",
    staffManagedTitle: "試験運営スタッフのマスターデータは統一IDに切り替わりました",
    staffManagedDescription:
      "このページでは sso-center のスタッフマスターデータを表示します。新規作成、編集、パスワードリセット、ロックなどの操作はプラットフォーム管理の「ID とアクセス」で維持してください。",
    modalTitle: "統一IDの受験者を連携",
    modalSubmit: "選択項目を連携",
    modalAlertTitle: "統一IDから受験者を連携",
    modalAlertDescription:
      "統一ID内の candidate ユーザーだけを連携します。認証は引き続き統一IDが担当し、試験側は受験者の業務プロファイルと試験関係だけを保持します。",
    bindModalTitle: "統一IDをローカルユーザーにバインド：{username}",
    bindModalSubmit: "バインドを確認",
    bindModalAlertTitle: "ローカルユーザーを統一IDにバインド",
    bindModalAlertDescription:
      "バインド後、以降の統一IDログインはユーザー名照合だけに依存せず、このローカル業務ユーザーを優先して解決します。",
    unbindConfirmTitle: "統一ID連携を解除",
    unbindConfirmDescription:
      "解除後、ローカルユーザー {username} は統一IDアカウントにバインドされなくなり、以降の統一IDログインでもこのローカル業務ユーザーには解決されません。",
    staffModalTitle: "統一IDのスタッフを連携",
    staffModalSubmit: "連携してロールを割り当て",
    staffModalAlertTitle: "統一IDから試験運営スタッフを連携",
    staffModalAlertDescription:
      "統一IDからスタッフを選択した後、複数のローカル業務ロールを一括で割り当てられます。統一IDはアカウントと基礎IDだけを担当し、exam は自身の業務ロールと権限の和集合だけを維持します。",
    remoteRole: "統一IDロール",
    linkedStatus: "連携状態",
    identitySource: "ソース",
    bindingSummary: "バインド関係",
    ssoBoundWithId: "SSO #{id} にバインド済み",
    linkedToLocalUser: "ローカルユーザーにバインド済み：{username}",
    linkedToLocalUserWithRole: "ローカルユーザーにバインド済み：{username}（{role}）",
    localOnly: "ローカルのみ",
    staffLinkSuccess: "統一IDのスタッフを連携しました：{linked}/{requested}",
    bindSuccess: "統一IDバインドを保存しました",
    unbindSuccess: "統一ID連携を解除しました",
  },
  importDialog: {
    templateDownload: "テンプレートをダウンロード",
    validatePreview: "検証してプレビュー",
    confirmImport: "インポートを確定",
    instruction:
      "先にテンプレートをダウンロードし、列ごとに入力してからアップロードして検証してください。エラーのない行だけが確定後に取り込まれます。",
    selectFile: "Excel ファイルを選択",
    selectedFile: "選択済み：{name}",
    summary: "全 {requested} 行：取込可能 {valid} 行、エラー {invalid} 行",
    rowNumber: "行番号",
    action: "操作",
    actionUpdate: "更新",
    actionCreate: "新規作成",
    errors: "エラー",
    pass: "成功",
  },
  customFields: {
    action: "カスタム項目",
    batchAction: "項目を一括設定 ({count})",
    dialogTitle: "受験者カスタム項目",
    batchDialogTitle: "受験者カスタム項目を一括設定（{count} 人選択中）",
    preview: "事前検証",
    apply: "実行を確定",
    instruction:
      "設定する項目と値を先に選び、事前検証を実行してから確定時に実際の書き込みを行います。",
    targetFields: "対象項目",
    targetFieldsPlaceholder: "一括設定する項目を選択",
    emptyHint: "項目を選択してから値を入力してください。",
    previewSummary: "検証結果：要求 {requested}、成功 {success}、失敗 {failed}",
    candidateId: "受験者ID",
    result: "結果",
    reason: "理由",
    pass: "成功",
    fail: "失敗",
  },
  confirm: {
    kickoutTitle: "このアカウントをサインアウトしますか？",
    kickoutDescription:
      "サインアウト後、このアカウントの現在のセッションは直ちに無効になり、再ログインが必要です。",
    resetPasswordTitle: "パスワードをリセットしますか？",
    resetPasswordDescription:
      "{username} にランダムな新しいパスワードを生成し、現在のセッションを無効にします。",
    batchLockTitle: "選択したアカウントをロックしますか？",
    batchLockDescription:
      "選択した {count} 名の受験者アカウントをロックし、現在のセッションを無効にします。",
    batchUnlockTitle: "選択したアカウントのロックを解除しますか？",
    batchUnlockDescription: "選択した {count} 名の受験者アカウントのロックを解除します。",
    batchClearAvatarTitle: "アバターを一括クリアしますか？",
    batchClearAvatarDescription: "選択した {count} 名の受験者のアバターをクリアします。",
    batchResetPasswordTitle: "選択したパスワードをリセットしますか？",
    batchResetPasswordDescription:
      "選択した {count} 名の受験者にランダムな新しいパスワードを生成し、現在のセッションを無効にします。",
  },
};
